import { useEffect, useState } from 'react';
const useTimeline = (from, to, current) => {
    const [percentage, setPercentage] = useState(0);
    const getLatestDate = () => {
        return new Date(to);
    };
    const getStartDate = () => {
        return new Date(from);
    };
    const getCurrentDate = () => {
        return new Date(current);
    };
    const getDaysBetween = (date1, date2) => {
        const DAY_IN_SECONDS = 24 * 60 * 60 * 1000;
        return Math.round(Math.abs((date1 - date2) / DAY_IN_SECONDS));
    };
    const getTotalMonths = () => {
        // Start at 1 so length always includes an actual start
        let months = 1;
        if (getLatestDate().getFullYear() === getStartDate().getFullYear()) {
            months += getLatestDate().getMonth() - getStartDate().getMonth();
        }
        else {
            // Add months between first and last year
            months +=
                (getLatestDate().getFullYear() -
                    getStartDate().getFullYear() -
                    1) *
                    12;
            // Add months of last year
            months += getLatestDate().getMonth();
            // Add months of first year
            months += 12 - getStartDate().getMonth(); // show start of month
        }
        return months;
    };
    const getTotalDays = () => {
        return getDaysBetween(getLatestDate(), getStartDate());
    };
    const getCurrentDays = () => {
        return getDaysBetween(getLatestDate(), getCurrentDate());
    };
    useEffect(() => {
        const calculatedPercentage = Math.ceil((getCurrentDays() / getTotalDays()) * 100);
        if (isNaN(calculatedPercentage)) {
            return;
        }
        setPercentage(calculatedPercentage);
    }, [current]);
    return {
        getTotalMonths,
        getLatestDate,
        getStartDate,
        getCurrentDate,
        percentage,
    };
};
export default useTimeline;
